// src/services/apiLabsService.js

import appConfig from '../config';

const API_URL = 'https://hub.apilabz.com';

export const validateToken = async (token) => {
    try {
        const response = await fetch(`${API_URL}/user/token`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.ok) {
            const data = await response.json();
            return { isValid: true, credits: data.credits };
        } else {
            const errorData = await response.json();
            return { isValid: false, errorMessage: errorData.error || 'Unable to validate token' };
        }
    } catch (error) {
        return { isValid: false, errorMessage: 'Network error. Please check your connection and try again.' };
    }
};

export const executeModule = async (token, appId, inputValues) => {
    const app = appConfig.apps[appId];
    if (!app) {
        throw new Error('Invalid app ID');
    }
    
    const moduleId = app.id;
    
    // Build request body from the input values
    const requestData = {};
    
    if (app.inputs) {
        // Add each input value to the request data
        app.inputs.forEach(input => {
            if (inputValues[input.key]) {
                requestData[input.key] = inputValues[input.key];
            }
        });
    } else {
        // Fallback for backward compatibility
        requestData[app.bodyKey] = inputValues[app.bodyKey] || inputValues;
    }
    
    // Special case for Perplexity
    if (appId === 'perplexitySearch') {
        requestData.model = 'sonar';
    }
    
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), (app.estimatedTime + 30) * 1000);

        // Use custom endpoint if specified, otherwise use the default
        const endpoint = app.endpoint || `${API_URL}/module/${moduleId}`;

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(requestData),
            signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'An error occurred during processing');
        }
        
        const result = await response.json();
        
        // Process the response based on app type
        return appConfig.processResponse(result, appId);
    } catch (error) {
        if (error.name === 'AbortError') {
            throw new Error('Request timed out. Please try again later.');
        }
        throw error;
    }
};